
import { compose, withState, withHandlers } from 'recompose';
import { withAxios } from 'op/components/auth';
import { withLocaleModification } from 'op/components/locale';
import { withOnlineStatus } from 'op/components/offline';
import { createHash } from 'crypto';
function validate(oldPassword, newPassword, confirmPassword) {
	if (!oldPassword || !newPassword || !confirmPassword)
		return false;
	if (oldPassword == newPassword)
		return false;
	if (newPassword != confirmPassword)
		return false;
	return true;
}

export const withSettingsModel = compose(
	withLocaleModification,
	withOnlineStatus,
	withAxios,
	withState('error', 'setError'),
	withState('success', 'setSuccess',false),
	withState('openModal', 'setOpenModal', false),
	withState('loading', 'setLoading', false),
	withState('oldPassword', 'setOldPassword', ''),
	withState('newPassword', 'setNewPassword', ''),
	withState('confirmPassword', 'setConfirmPassword', ''),
	withHandlers({
		change: ({ axios,confirmPassword, setConfirmPassword, oldPassword, setOldPassword, newPassword, setNewPassword, setLoading, setError, setOpenModal,setSuccess }) => async () => {
			if (validate(oldPassword, newPassword, confirmPassword)) {
				setLoading(true);
				var response;
				try {
					response = await axios.post('/api/auth/changePassword', {
						oldp: oldPassword, //createHash('sha256').update(oldPassword).digest('base64'),
						newp: newPassword //createHash('sha256').update(newPassword).digest('base64'),
					});
				}
				catch (ex) {
					setError(ex)
				}
				setLoading(false);
				setConfirmPassword("");
				setOldPassword("");
				setNewPassword("");
				if (!response || !response.data) {
					return setError("error");
				}
				else {
					//setOpenModal(false)
					setSuccess(true);
				}
				
			}
			else {
				setConfirmPassword("");
				setOldPassword("");
				setNewPassword("");
				return setError("error");
			}
		},
		reset:({setSuccess,setOpenModal,setError}) => async () => {
			setError("");
			setSuccess(false);
			setOpenModal(false)
		}
	}),
);
